import type { QariProfileDraft } from '@/types/qari';
import {
  QariFormField,
  QariTextArea,
  QariTextInput,
} from '@/components/qari/QariFormField';
import { TagInput } from '@/components/qari/TagInput';

type StepPersonalProps = {
  value: Partial<QariProfileDraft>;
  onChange: (patch: Partial<QariProfileDraft>) => void;
  disabled?: boolean;
};

export function StepPersonal({
  value,
  onChange,
  disabled,
}: StepPersonalProps) {
  return (
    <div className="space-y-6">
      <QariFormField
        label="Full name"
        htmlFor="qari-full-name"
        required
        hint="As it should appear on your public profile."
      >
        <QariTextInput
          id="qari-full-name"
          value={value.full_name ?? ''}
          onChange={(v) => onChange({ full_name: v })}
          maxLength={120}
          disabled={disabled}
          placeholder="e.g. Sheikh Abdullah Rahman"
        />
      </QariFormField>

      <QariFormField
        label="Short bio"
        htmlFor="qari-bio"
        hint="2–4 sentences. Background, style, what students should know."
      >
        <QariTextArea
          id="qari-bio"
          value={value.bio ?? ''}
          onChange={(v) => onChange({ bio: v })}
          rows={5}
          maxLength={2000}
          disabled={disabled}
          placeholder="Studied at… recites in the style of… teaches…"
        />
      </QariFormField>

      <div className="grid sm:grid-cols-2 gap-6">
        <QariFormField label="Country" htmlFor="qari-country">
          <QariTextInput
            id="qari-country"
            value={value.country ?? ''}
            onChange={(v) => onChange({ country: v })}
            maxLength={64}
            disabled={disabled}
            placeholder="e.g. Pakistan"
          />
        </QariFormField>
        <QariFormField label="City" htmlFor="qari-city">
          <QariTextInput
            id="qari-city"
            value={value.city ?? ''}
            onChange={(v) => onChange({ city: v })}
            maxLength={80}
            disabled={disabled}
            placeholder="e.g. Karachi"
          />
        </QariFormField>
      </div>

      <QariFormField
        label="Languages"
        hint="Languages you can teach in. Press Enter to add each one."
      >
        <TagInput
          value={value.languages ?? []}
          onChange={(v) => onChange({ languages: v })}
          placeholder="Arabic, Urdu, English…"
          disabled={disabled}
        />
      </QariFormField>
    </div>
  );
}
